import React__default from 'react';
import PropTypes from 'prop-types';
import { IconContainer } from './Dropdown.styles.js';
import { DROPDOWN_SIZE } from './Dropdown.constants.js';
import Icon from '../../Icon/index.js';

var getIconSize = function getIconSize(size) {
  return size === DROPDOWN_SIZE.REGULAR ? 'regular' : 'small';
};
var DropdownIndicator = function DropdownIndicator(_ref) {
  var selectProps = _ref.selectProps;
  var menuIsOpen = selectProps.menuIsOpen,
    isSearchable = selectProps.isSearchable,
    size = selectProps.size,
    isDisabled = selectProps.isDisabled;
  var variant = menuIsOpen && isSearchable ? 'Search' : 'ChevronDown';
  return React__default.createElement(IconContainer, {
    $rotate: menuIsOpen && !isSearchable,
    $isDisabled: isDisabled
  }, React__default.createElement(Icon, {
    variant: variant,
    size: getIconSize(size)
  }));
};
DropdownIndicator.propTypes = {
  selectProps: PropTypes.shape({
    isDisabled: PropTypes.bool.isRequired,
    isSearchable: PropTypes.bool.isRequired,
    menuIsOpen: PropTypes.bool.isRequired,
    size: PropTypes.oneOf(Object.values(DROPDOWN_SIZE))
  }).isRequired
};

export { DropdownIndicator };
//# sourceMappingURL=DropdownIndicator.js.map
